import ApiClient from './ApiClient';

export default class ApiDevice {
    static getDevices = () => {
        return ApiClient.get({
            url: '/api/admin/device',
        });
    }

    static toggleDevice = (id) => {
        return ApiClient.get({
            url: '/api/admin/device/' + id + '/toggle',
        });
    }

    static toggleDevicePublic = (id) => {
        return ApiClient.get({
            url: '/api/admin/device/' + id + '/public/toggle',
        });
    }

    static toggleDeviceForecast = (id) => {
        return ApiClient.get({
            url: '/api/admin/device/' + id + '/toggle_forecast',
        })
    }

    static updateDevice = (id, data) => {
        return ApiClient.post({
            url: '/api/admin/device/' + id + '/locate',
            body: data
        });
    }

    static addLogoToDevice = (id, data) => {
        return ApiClient.post({
            url: '/api/admin/device/' + id + '/logo',
            body: data
        });
    }

    static setDeviceToDefault = (id) => {
        return ApiClient.get({
            url: '/api/admin/device/' + id + '/locate'
        });
    }

    static toggleReports = (id, data) => {
        return ApiClient.patch({
            url: '/api/admin/device/' + id + '/send_reports',
            body: data
        });
    }

    static getRecipients = (id) => {
        return ApiClient.get({
            url: '/api/device/' + id + '/recipients',
        });
    }

    static addRecipient = (id, data) => {
        return ApiClient.post({
            url: '/api/device/' + id + '/recipients',
            body: data
        });
    }

    static removeRecipient = (deviceId, recipientId) => {
        return ApiClient.del({
            url: '/api/device/' + deviceId + '/recipients/' + recipientId,
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/ApiDevice.js